import Vue from "vue";
import VueRouter from "vue-router";

import NProgress from "nprogress";
import "nprogress/nprogress.css";
Vue.use(VueRouter);

const routes = [{
        path: '/index',
        name: 'Index',
        component: () =>
            import ( /* webpackChunkName: "layout" */ "../layouts/Headmain.vue"),
        children: [{
                path: "/index",
                name: "index",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import ( /* webpackChunkName: "index" */ "../views/Index"),
            },


        ]
    },
    {
        path: '/alum',
        name: 'Alum',
        component: () =>
            import ( /* webpackChunkName: "layout" */ "../layouts/Headmain.vue"),
        children: [{
                path: "/Alum",
                name: "alum",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import ( /* webpackChunkName: "index" */ "../views/Alum"),
            },


        ]
    },
    {
        path: '/search',
        name: 'Search',
        component: () =>
            import ( /* webpackChunkName: "layout" */ "../layouts/Headmain.vue"),
        children: [{
                path: "/Search",
                name: "search",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import ( /* webpackChunkName: "index" */ "../views/Search"),
            },


        ]
    },
    {
        path: '/downlog',
        name: 'downlog',
        component: () =>
            import ( /* webpackChunkName: "index" */ "../views/Downlogview"),

    },


]


const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});
router.beforeEach((to, from, next) => {
    console.log(to)
    if (to.path == '/') {
        next({
            path: '/index'
        })

    }
    if (to.path !== from.path) {
        NProgress.start();
    }
    if (from.path == '/alum') {
        //  window.location.href = document.referrer;
        console.log("aaa")
    }
    console.log(from.path)
    NProgress.done();

    next();

});
router.afterEach(() => {
    NProgress.done();
})

export default router;